import React, {
  CSSProperties, useEffect,  useState,
} from 'react';
import { Accordion, useAccordionButton } from 'react-bootstrap';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import ReactGA from 'react-ga4';
import {
  Caption,
  FontWeightType, HeadingLarge, HeadingMedium, LabelLarge, LabelMedium,
} from '../../../component/Text';
import { MainButton } from '../../../component/button';
import HomeBgWrapper from './homeBgWrapper';
import ResponsivePaddingWrapper, {
  ResponsiveFlexDirection,
} from '../../../component/responsive/responsivePaddingWrapper';
import { FadeInDirectionType, FadeWrapper } from '../../../component/animation/animationWrapper';
import { useMobile } from '../../../hook/usePlatform';
import SlackAPI from '../../../util/slackAPI';
import { QnAPolicyModal } from '../../../component/modal/policy/policyModal';
import { lineColor } from '../../../util/colors';
import InputItem from '../../../component/inputItem';

export const QnAInfo: React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;
  const [selectedAccodian, setSelectedAccodian] = useState<AccordionEventKey>(undefined);
  return (
    <ResponsivePaddingWrapper mobilePadding={10} style={{ borderTop: border }}>
      <div
        id="qna"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingBlock: isMobile ? 40 : 160,
        }}
      >
        <Caption
          style={{ color: '#A01E22', fontFamily: 'inter' }}
          fontWeight={FontWeightType.w700}
        >
          Q&A
        </Caption>
        <HeadingMedium fontWeight={FontWeightType.w700}>
          자주 묻는 질문
        </HeadingMedium>
        <Accordion
          style={{ width: '100%', marginTop: 66 }}
          onSelect={(eventKey) => { setSelectedAccodian(eventKey); }}
        >
          <QnAInfoItem
            question="기존 결혼정보회사와 무엇이 다른가요?"
            answer={'기존 결혼정보회사는 결혼을 목표로 조건 중심의 만남을 주선하고 결혼 성사 시 성혼비를 추가로 지불해야 합니다.\n\n반면 시럽인연은 편안한 관계형성을 위한 신뢰 기반의 만남을 제공합니다.'}
            eventKey="0"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="신청 가능한 나이는 어떻게 되나요?"
            answer="시럽인연은 40세 이상 중장년을 대상으로 하는 1:1 프리미엄 소개팅 서비스입니다. 40세 이상만 신청하실 수 있습니다."
            eventKey="1"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="13단계 인증 시스템이란 무엇인가요?"
            answer="신원, 재산, 건강 정보를 포함한 총 13가지 필수 인증 절차를 통해 안전하고 신뢰할 수 있는 만남을 보장하는 시스템입니다."
            eventKey="2"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="개인정보 보호는 어떻게 이루어지나요?"
            answer="모든 제출된 정보는 철저한 보안 시스템으로 보호되며, 본인의 동의 없이는 절대 공개되지 않습니다."
            eventKey="3"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="Si-Love AI Matching 시스템이 어떻게 작동하나요?"
            answer="가치관, 성향, MBTI, 라이프스타일 등의 심층 성향 분석을 기반으로 최적의 인연을 추천합니다. 단순한 프로필 매칭이 아닌 깊이 있는 분석을 진행합니다."
            eventKey="4"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="전담 컨설턴트의 역할은 무엇인가요?"
            answer="회원님의 성향과 취향을 파악하여 계약 기간 동안 맞춤형 매칭을 전담 지원합니다. 매칭 이후에도 관계 발전을 위한 조언을 제공해 드립니다."
            eventKey="5"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="심리 상담과 관계 코칭 서비스는 어떻게 진행되나요?"
            answer="전문가와의 1:1 상담을 통해 관계 발전에 필요한 조언을 제공하고, 연애 감각을 되찾을 수 있도록 맞춤형 코칭을 진행합니다."
            eventKey="6"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="심리 상담을 받아야만 매칭이 가능한가요?"
            answer="필수 사항은 아니지만, 원활한 관계 형성을 위해 적극 권장해 드리는 서비스입니다."
            eventKey="7"
            selectedEventKey={selectedAccodian}
          />
          <QnAInfoItem
            question="상담비는 무료인가요?"
            answer="서비스 가입과 매칭 정보 제출을 위한 전문 컨설턴트와의 상담은 무료입니다."
            eventKey="8"
            selectedEventKey={selectedAccodian}
          />

        </Accordion>
      </div>
    </ResponsivePaddingWrapper>
  );
};
interface QnAInfoItemProps {
  question:string;
  answer:string;
  eventKey:string;
  selectedEventKey?:AccordionEventKey;
}
const QnAInfoItem:React.FC<QnAInfoItemProps> = (props) => {
  const isMobile = useMobile();
  const onClick = useAccordionButton(props.eventKey);

  return (
    <div
      style={{
        marginBottom: 30,
        backgroundColor: 'white',
        paddingInline: 28,
      }}
      onClick={onClick}
    >
      <div style={{
        display: 'flex', gap: 5, paddingBlock: 28, alignItems: 'flex-start',
      }}
      >
        <LabelLarge style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>Q.</LabelLarge>
        <LabelLarge style={{ fontFamily: 'inter', flex: 1 }} fontWeight={FontWeightType.w700}>{props.question}</LabelLarge>
        <div
          style={{
            transform: props.selectedEventKey === props.eventKey ? 'rotate(180deg)' : '',
          }}
        >
          <img
            alt="modal_close"
            src="/svg/arrow.svg"
          />
        </div>
      </div>
      <Accordion.Collapse eventKey={props.eventKey}>
        <div
          style={{
            paddingBlock: 28,
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderColor: '#434343',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: 5,
              width: isMobile ?  '80%' : '40%',
            }}
          >
            <LabelLarge style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>A.</LabelLarge>
            <LabelLarge style={{ fontFamily: 'inter', flex: 1 }} fontWeight={FontWeightType.w700}>{props.answer}</LabelLarge>
          </div>
        </div>
      </Accordion.Collapse>
    </div>
  );
};

interface RequestQnAType {
  btn?: string,
  style?: CSSProperties
}

export const RequestQnA: React.FC<RequestQnAType> = ({ btn = '문의하기', style = {} }) => {
  const isMobile = useMobile();
  const [name, setName] = useState<string>('');
  const [nameError, setNameError] = useState<boolean>(false);
  const [phone, setPhone] = useState<string>('');
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [date, setDate] = useState<string>('');
  const [dateError, setDateError] = useState<boolean>(false);
  const [time, setTime] = useState<string>('');
  const [timeError, setTimeError] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');
  const [showPivatePolicy, setShowPrivatePolicy] = useState(false);
  const onConsult = async () => {
    ReactGA.event({
      category: 'button',
      label: '상담신청',
      action: 'ButtonPress',
    });
    const nameEmpty = name.length === 0;
    const phoneEmpty = phone.length === 0;
    setNameError(nameEmpty);
    setPhoneError(phoneEmpty);

    if (nameEmpty || phoneEmpty) {
      return;
    }
    const result = await SlackAPI.postQnAMessage({
      name, phone, content,
    });
    if (result) {
      alert('상담신청이 접수되었습니다.');
      setName('');
      setPhone('');
      setContent('');
      setTime('');
      setDate('');
    } else {
      alert('오류가 발생했습니다. 나중에 다시 시도해 주세요.');
    }
  };
  useEffect(() => {
    if (nameError) {
      setNameError(false);
    }
  }, [name]);
  useEffect(() => {
    if (phoneError) {
      setPhoneError(false);
    }
  }, [phone]);
  useEffect(() => {
    if (timeError) {
      setTimeError(false);
    }
  }, [time]);
  useEffect(() => {
    if (dateError) {
      setDateError(false);
    }
  }, [date]);
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingInline: isMobile ? 30 : 64,
      paddingBlock: isMobile ? 40 : 160,
      ...style,
    }}
    >
      <QnAPolicyModal visible={showPivatePolicy} setVisible={setShowPrivatePolicy} />
      <InputItem
        title="이름"
        placeholder="성함을 입력해주세요."
        isError={nameError}
        errorText="미 입력"
        value={name}
        setValue={setName}
        required
      />
      <InputItem
        style={{ marginTop: 16 }}
        title="연락처"
        isError={phoneError}
        errorText="미 입력"
        placeholder="상담 가능한 연락처를 알려주세요."
        value={phone}
        setValue={setPhone}
        required
      />
      <InputItem
        style={{ marginTop: 16 }}
        title="문의 내용"
        placeholder="자세한 문의 내용이나 궁금하신 점을 남겨주세요."
        value={content}
        setValue={setContent}
        isTextArea
      />
      <div style={{
        display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 44,
      }}
      >
        <LabelMedium style={{ fontFamily: 'inter' }}>개인정보 수집 및 보호 이용에 동의합니다.</LabelMedium>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setShowPrivatePolicy(true);
            // window.location.href = 'https://sinor.co.kr/53'
          }}
        >
          <LabelMedium style={{
            fontFamily: 'inter',
            color: 'gray',
            textDecorationColor: 'gray',
            textDecoration: 'underline',
          }}
          >
            전문
          </LabelMedium>
        </div>
      </div>
      <MainButton style={{ marginTop: 32, width: '100%' }} text={btn} onPress={onConsult} />
    </div>
  );
};
const QnASection: React.FC = () => {
  const isMobile = useMobile();
  return (
    <HomeBgWrapper
      style={{
        position: 'relative',
      }}
    >
      <ResponsiveFlexDirection>
        <div
          style={{
            height: '100%',
            flex: 1,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'flex-start' : 'center',
              paddingBlock: isMobile ? 40 : 160,
              paddingInline: isMobile ? 30 : 30,
            }}
          >
            <div style={{ paddingInlineEnd: isMobile ? 0 : 50 }}>
              <Caption style={{ color: '#A01E22' }}>상담 신청</Caption>
              <HeadingLarge fontWeight={FontWeightType.w700}>
                지금 문의를 남겨주세요
              </HeadingLarge>
              <div style={{ height: isMobile ? 12 : 64 }} />
              <FadeWrapper
                direction={FadeInDirectionType.rtl}
                fadeInDistance={10}
                delay={0.5}
              >
                <LabelMedium style={{ fontFamily: 'inter' }}>
                  {'지금 이 순간 마음에 가장 필요한 답을 드립니다.\n귀 기울이는 진심어린 상담으로,\n소중한 이야기를 신뢰와 존중으로 다루겠습니다.\n\n모든 상담 내용은 철저히 비공개로 관리되며\n순차적으로 빠르게 연락드리겠습니다.\n\n언제든 편안한 마음으로 문의해 주세요.'}
                </LabelMedium>

              </FadeWrapper>

            </div>
          </div>
        </div>
        {!isMobile ? (
          <div
            style={{
              position: 'absolute',
              left: '50%',
              height: '100%',
              width: '1px',
              backgroundColor: lineColor,
            }}
          />
        ) : null}
        <div style={{ flex: 1 }}>
          <RequestQnA />
        </div>

      </ResponsiveFlexDirection>
    </HomeBgWrapper>
  );
};

interface RadioItemType {
  column :boolean,
  isError :boolean,
  subTittle :string,
  errorText :string,
  options :string[],
  style :CSSProperties,
  value :string,
  setValue(e:string):void,
  title:string,
  required?:boolean,
}
const RadioItem:React.FC<RadioItemType> = ({
  column = true,
  isError = false,
  subTittle = '',
  errorText = '',
  options = ['noValue'],
  style = {},
  value = '',
  setValue = () => {},
  title = '',
  required = false,
}) => (
  <div style={{
    display: 'flex', width: '100%', flexDirection: 'column', ...style,
  }}
  >
    <div style={{ display: 'flex', marginInlineEnd: 20 }}>
      <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w700}>{title}</LabelMedium>
      {required ? <div style={{ color: 'red' }}>*</div> : null}
    </div>
    {subTittle != null
                && <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w700}>{subTittle}</LabelMedium>}
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', flexDirection: column ? 'column' : 'row', gap: 8 }}>
        {options.map((e) => (
          <div
            key={`checker_${e}`}
            style={{ display: 'flex', gap: 8 }}
            onClick={() => {
              let list = value.split(',');
              const idx = list.findIndex((f) => f === e);

              if (idx === -1) {
                list.push(e);
              } else {
                list = list.filter((f) => f !== e);
              }
              setValue(list.filter((f) => f.length > 0).join(','));
            }}
          >
            <img
              alt="checker"
              style={{ cursor: 'pointer' }}
              src={value.split(',').findIndex((f) => f === e) === -1 ? '/svg/radio_unCheck.svg' : '/svg/radio_check.svg'}
            />
            <LabelMedium style={{ fontFamily: 'inter' }}>{e}</LabelMedium>
          </div>
        ))}
      </div>
      <LabelMedium
        fontWeight={FontWeightType.w600}
        style={{
          fontFamily: 'inter',
          color: isError ? '#DF5C5C' : 'transparent',
        }}
      >
        {errorText}
      </LabelMedium>
    </div>
  </div>
);

export default QnASection;
